import { render } from "./SisterBreedsView.vue?vue&type=template&id=27cd5c71&scoped=true"
import script from "./SisterBreedsView.vue?vue&type=script&lang=js"
export * from "./SisterBreedsView.vue?vue&type=script&lang=js"

import "./SisterBreedsView.vue?vue&type=style&index=0&id=27cd5c71&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cd5c71"]])

export default __exports__